import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Contact, contact } from './contact';
import { contactButtons, MediaType } from '@nice-ccf/core-sdk';

export const SIMULATORV2_FEATURE_KEY = 'simulatorV2';

export interface SimulatorV2State {
  contact: Array<Contact>;
  selectedContact: any;
  createNewJourney: boolean;
  selectedMedia: string;
  selectedChannel: string;
}

const initialSimulatorV2State: SimulatorV2State = {
  contact: contact as Contact[],
  selectedContact: contact[0] as Contact,
  createNewJourney: false,
  selectedMedia: 'Voice',
  selectedChannel: 'Chat',
};

export const simulatorV2Slice = createSlice({
  name: SIMULATORV2_FEATURE_KEY,
  initialState: initialSimulatorV2State,
  reducers: {
    setSelectedContact: (state, action: PayloadAction<any>) => {
      // state.selectedContact =
      //   (Array.isArray(initialSimulatorV2State.contact) &&
      //     initialSimulatorV2State.contact.find((item) => {
      //       if (action.payload.media === 'Digital') {
      //         return item.channel === action.payload.channel;
      //       }
      //       return item.media === action.payload.media;
      //     })) ||
      //   ({} as Contact);
      state.selectedContact = action.payload;
    },
    setCreateNewJourney: (state, action: PayloadAction<boolean>) => {
      state.createNewJourney = action.payload;
    },
    setSelectedMedia: (state, action: PayloadAction<string>) => {
      state.selectedMedia = action.payload;
    },
    setSelectedChannel: (state, action: PayloadAction<string>) => {
      state.selectedChannel = action.payload;
    },
    /**
     *
     * @param state -
     * @param action -
     * @example
     * @returns
     */
    updateselectedContact(
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) {
      const { field, value } = action.payload;
      const currentContact = { ...state.selectedContact };
      const addressFields = [
        'customerPrimaryAddress.address1',
        'customerPrimaryAddress.address2',
        'customerPrimaryAddress.city',
        'customerPrimaryAddress.state',
        'customerPrimaryAddress.zip',
        'customerPrimaryAddress.country',
      ];
      const customerFields = [
        'firstName',
        'middleName',
        'lastName',
        'phoneNo',
        'replywithApproval',
        'twitterId',
        'emailId',
        'externalDataLoyaltyInfoHide',
        'consumerCardTicketTabHide',
      ];

      const currentUpdatedContact = customerFields.includes(field)
        ? {
            ...currentContact,
            customer: {
              ...currentContact.customer,
              [field.substring(field.lastIndexOf('.') + 1)]: value,
            },
          }
        : addressFields.includes(field)
        ? {
            ...currentContact,
            customer: {
              ...currentContact.customer,
              customerPrimaryAddress: {
                ...currentContact.customer.customerPrimaryAddress,
                [field.substring(field.lastIndexOf('.') + 1)]: value,
              },
            },
          }
        : { ...currentContact, [field]: value };
      if (field === 'channel' && value === 'Email') {
        currentUpdatedContact.contactButtons = [contactButtons.commit];
        currentUpdatedContact.messageType = 'Email';
        currentUpdatedContact.queueName =
          'RE: Where is my refund? i cannot beleive';
      } else if (field === 'media' && value === 'Digital') {
        currentUpdatedContact.channel = 'Email';
      } else if (
        (field === 'customerChatReply' ||
          field === 'customerChatReplyJsonData' ||
          (field === 'channel' && value === 'Chat')) &&
        currentUpdatedContact.media !== MediaType.VOICE
      ) {
        currentUpdatedContact.contactButtons = [contactButtons.commit];
        currentUpdatedContact.messageType = 'Chat';
        currentUpdatedContact.queueName = '';
      } else {
        if (currentUpdatedContact.media === MediaType.DIGITAL) {
          if (
            field === 'channel' &&
            value === 'Chat' &&
            currentUpdatedContact?.copilotAssist === 'Yes'
          ) {
            currentUpdatedContact.contactButtons = [
              contactButtons.cobrowsing,
              contactButtons.commit,
              contactButtons.location,
            ];
            currentUpdatedContact.messageType = 'Chat';
            currentUpdatedContact.queueName = 'VIP Client';
          } else {
            currentUpdatedContact.messageType = 'Post';
            currentUpdatedContact.queueName = 'Mention';
          }
        }
      }
      if (currentUpdatedContact.media === MediaType.VOICE) {
        currentUpdatedContact.contactButtons = [
          contactButtons.hold,
          contactButtons.mask,
          contactButtons.mute,
          contactButtons.keypad,
          contactButtons.transfer,
          contactButtons.record,
          //contactButtons.commit,
          contactButtons.hungup,
        ];
      } else if (currentUpdatedContact.media === MediaType.DIGITAL) {
        currentUpdatedContact.contactButtons = [
          contactButtons.transfer,
          contactButtons.commit,
        ];
      } else if (currentUpdatedContact.media === MediaType.VIDEOCALL) {
        currentUpdatedContact.channel = 'VideoCall';
        currentUpdatedContact.messageType = 'VideoCall';
        currentUpdatedContact.queueName = 'Damaged Luggage';
      }
      return {
        ...state,
        selectedContact: {
          ...state.selectedContact,
          ...currentUpdatedContact,
        },
      };
    },

    /**
     *
     * @param state -
     * @param action -
     * @example
     * @returns
     */
    updateselectedCustomer(
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) {
      const currentContact = { ...state.selectedContact };
      const currentUpdatedContact = {
        ...currentContact,
        customer: {
          ...currentContact.customer,
          ...action.payload,
        },
      };

      return {
        ...state,
        contact: currentUpdatedContact,
      };
    },
  },
});

/*
 * Export reducer for store configuration.
 */
export const simulatorV2Actions = simulatorV2Slice.actions;
export const simulatorV2Reducer = simulatorV2Slice.reducer;

export const {
  setSelectedContact,
  setCreateNewJourney,
  setSelectedMedia,
  setSelectedChannel,
  updateselectedContact,
  updateselectedCustomer,
} = simulatorV2Slice.actions;

/**
 *
 * @param rootState -
 * @example -
 * @returns
 */
const getSimulatorV2State = (rootState: { simulatorV2: SimulatorV2State }) => {
  return rootState[SIMULATORV2_FEATURE_KEY];
};

export const getCreateNewJourney = createSelector(
  getSimulatorV2State,
  (state) => state.createNewJourney
);

export const getSelectedMedia = createSelector(
  getSimulatorV2State,
  (state) => state.selectedMedia
);
export const getSelectedChannel = createSelector(
  getSimulatorV2State,
  (state) => state.selectedChannel
);
export const getSelectedContact = createSelector(
  getSimulatorV2State,
  (state) => state.selectedContact
);
